const Users = [
    {
        id: 'user',
        password: 'user',
        name: '멀캠' 
    }
]

export default Users
